
export const generateRandomString = (length = 20) => {
  const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const values = new Uint32Array(length);
  const crypto = window.crypto ? window.crypto : window.msCrypto;
  crypto.getRandomValues(values);

  let output = "";

  for (let i = 0; i < length; i += 1) {
    const mod = values[i] % characters.length;
    const result = characters[mod];
    output += result;
  }
  return output;
};



// WEBPACK FOOTER //
// ./src/js/utils/random.js